import OrganizationFleetTree from '@/models/OrganizationFleetTree'
import OrganizationDeviceTreeTransformer from '@/transformers/OrganizationDeviceTreeTransformer'
import CollectionTransformer from '@/transformers/CollectionTransformer'
import OrganizationVehicleTreeTransformer from '@/transformers/OrganizationVehicleTreeTransformer'

export default class OrganizationFleetTreeTransformer {
    constructor (
        collectionTransformer = new CollectionTransformer(),
        organizationDeviceTreeTransformer = new OrganizationDeviceTreeTransformer(),
        organizationVehicleTreeTransformer = new OrganizationVehicleTreeTransformer()
    ) {
        this.collectionTransformer = collectionTransformer
        this.organizationDeviceTreeTransformer = organizationDeviceTreeTransformer
        this.organizationVehicleTreeTransformer = organizationVehicleTreeTransformer
    }

    transform (data) {
        let fleet = new OrganizationFleetTree(
            data.id,
            data.level,
            data.name,
            data.vehiclesCount
        )

        fleet.setParent(parent || null)

        let vehicles = []
        data.vehicles.forEach((vehicleItem) => {
            let vehicleTransformed = this.organizationVehicleTreeTransformer.transform(vehicleItem)
            vehicleTransformed.setParent(fleet)
            vehicles.push(vehicleTransformed)
        })

        if (0 !== vehicles.length) {
            fleet.setVehicles(vehicles)
        }

        let devices = []
        if (null != data.devices) {
            data.devices.forEach((vehicleItem) => {
                let deviceTransformed = this.organizationDeviceTreeTransformer.transform(vehicleItem)
                deviceTransformed.setParent(fleet)
                devices.push(deviceTransformed)
            })
        }

        if (0 !== devices.length) {
            fleet.setDevices(devices)
        }

        return fleet
    }
}
